<template>
    <div>
        <div class="tabs">
            <ul>
                <li v-for="tab in tabs" :class="{ 'is-active': tab.isActive }">
                    <a :href="tab.href" @click="selectTab(tab)">{{ tab.name }}</a>
                </li>
            </ul>
        </div>

        <div class="tabs-details">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Tabs",
        data() {
            return {
                tabs: []
            };
        },

        computed: {
            activeTab: function () {
                return this.tabs.find(tab => {
                    return (tab.isActive === true);
                })
            }
        },

        created() {
            this.tabs = this.$children;
        },

        mounted() {
            this.tabs.forEach(tab => {
                if (tab.isActive) {
                    $('.tabs-details').css('height', $(tab.$el).height());
                }
            })
        },

        methods: {
            selectTab(selectedTab) {
                this.tabs.forEach(tab => {
                    tab.isActive = (tab.name === selectedTab.name);
                });
                $('.tabs-details').css('height', $(selectedTab.$el).height());
                this.$emit('tab-changed', selectedTab.name);
            }
        }
    }
</script>

<style scoped>
    .tabs {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        align-items: stretch;
        display: flex;
        font-size: 1rem;
        justify-content: space-between;
        overflow: hidden;
        overflow-x: auto;
        white-space: nowrap;
    }

    .tabs ul {
        align-items: center;
        border-bottom: 1px solid #dbdbdb;
        display: flex;
        flex-grow: 1;
        flex-shrink: 0;
        justify-content: flex-start;
    }

    ul {
        list-style: none;
    }

    .tabs:not(:last-child) {
        margin-bottom: 1.5rem;
    }

    .tabs li.is-active a {
        border-bottom: 4px solid #37A735;
        color: black;
        font-weight: bold;
    }

    .tabs a {
        align-items: center;
        color: #4a4a4a;
        display: flex;
        justify-content: center;
        margin-bottom: -1px;
        padding: .5em 1em;
        vertical-align: top;
        text-decoration: none;
    }
</style>
